import {
  LangingPageExportDataArgs,
  RouteDataArgs,
  RouteExportDataArgs,
  RoutePerStoreDataArgs,
  RtsDataArgs,
  StoreAssociatedRoutesDataArgs,
  StoreDataArgs,
} from "../../../pages/dedicatedDelivery/DdTypes";
import { ClientDataArgs } from "../../features/dedicatedDelivery/dashboardSlice";
import { StoreAddOrUpdateValidation } from "../../features/dedicatedDelivery/storeSlice";
import {
  BulkStoreIngestionResponse,
  ClientUIResponse,
  DdClientPerformanceUIResponse,
  DdGeneralClientUIResponse,
  DdRouteDashboardUIResponse,
  DdRouteImportUIResponse,
  DdRouteProgressUIResponse,
  DdStorePerformanceUIResponse,
  FilterValuesByFieldResponse,
  RtsEventTypesUIResponse,
  RtsUIResponse,
} from "../../models/ApiResponse";
import {
  AddRtsRequest,
  EditRtsRequest,
} from "../../models/requestModels/RtsRequestAdminPanel";
import {
  AddClaimRequest,
  AddLateCancelRequest,
  AddStoreRequest,
  EditStoreRequest,
  UpdateClaimRequest,
  UpdateLateCancelRequest,
} from "../../models/requestModels/StoreRequest";
import { BulkStoreIngestionWrapper } from "../../models/responseModels/BulkStoreIngestionWrapper";
import {
  DdRouteProgressDtoWrap,
  DdRouteProgressRequest,
} from "../../models/responseModels/DdRouteProgressResponse";
import { DdRouteDtoWrap } from "../../models/responseModels/DdRouteResponse";
import { axiosRequests } from "../axiosRequest";

export const DedicatedDeliveryAgent = {
  getClientDashboardData: (clientDataArgs: ClientDataArgs) =>
    axiosRequests.getWithQueryParam<DdClientPerformanceUIResponse>(
      "/fdc-commandops/dedicated-delivery/overview-of-clients",
      {
        params: {
          startDate: clientDataArgs.startDate,
          endDate: clientDataArgs.endDate,
        },
      }
    ),
  getRouteData: (args: RouteDataArgs) => {
    return axiosRequests.post<DdRouteDashboardUIResponse>(
      "/fdc-commandops/dedicated-delivery/routes",
      {
        client_id: args.clientId,
        page_size: args.pageSize,
        page_index: args.pageIndex,
        start_date: args.startDate,
        end_date: args.endDate,
        filters: args.filters,
      }
    );
  },
  getRtsPackageData: (args: RtsDataArgs) =>
    axiosRequests.post<RtsUIResponse>("/fdc-commandops/rts", {
      clientId: args.clientId,
      size: args.pageSize,
      page: args.pageIndex,
      startDate: args.startDate,
      endDate: args.endDate,
      filters: args.filters,
    }),

  getValuesByFieldForRts: (
    startDateP: string,
    endDateP: string,
    columnName: string,
    clientId: number
  ) => {
    return axiosRequests.getWithQueryParam<FilterValuesByFieldResponse>(
      "/fdc-commandops/rts/unique-values-by-field",
      {
        params: {
          start_date: startDateP,
          end_date: endDateP,
          field_name: columnName,
          client_id: clientId,
        },
      }
    );
  },
  getRtsEventTypes: (clientId: number) =>
    axiosRequests.getWithQueryParam<RtsEventTypesUIResponse>(
      "/fdc-commandops/rts/event-types",
      {
        params: {
          clientId: clientId,
        },
      }
    ),
  getRouteDataPerStore: (args: RoutePerStoreDataArgs) =>
    axiosRequests.post<DdRouteDashboardUIResponse>(
      "/fdc-commandops/dedicated-delivery/routes-by-store",
      {
        client_id: args.clientId,
        store_id: args.storeId,
        page_index: args.pageIndex,
        page_size: args.pageSize,
        start_date: args.startDate,
        end_date: args.endDate,
        filters: args.filter,
      }
    ),

  storeRouteData: (routesWrap: DdRouteDtoWrap) =>
    axiosRequests.post<DdRouteImportUIResponse>(
      "/fdc-commandops/dedicated-delivery/persist-new-routes",
      {
        routeInfo: routesWrap.routes,
        client_id: routesWrap.clientId,
        createdBy: routesWrap.createdBy,
        updatedBy: routesWrap.updatedBy,
      }
    ),
  storeRouteProgressData: (routesWrap: DdRouteProgressDtoWrap) =>
    axiosRequests.post<DdRouteImportUIResponse>(
      "/fdc-commandops/dedicated-delivery/persist-new-route-progress-dedicated",
      {
        routeProgress: routesWrap.routes,
        client_id: routesWrap.clientId,
        createdBy: routesWrap.createdBy,
        updatedBy: routesWrap.updatedBy,
      }
    ),
  getRouteProgressData: (args: DdRouteProgressRequest) =>
    axiosRequests.post<DdRouteProgressUIResponse>(
      "/fdc-commandops/dedicated-delivery/get-route-progress-dedicated",
      {
        clientId: args.clientId,
        startDate: args.startDate,
        endDate: args.endDate,
      }
    ),
  exportFdpRouteProgressData: (args: DdRouteProgressRequest) =>
    axiosRequests.post<any>(
      "/fdc-commandops/dedicated-delivery/export-fdp-route-progress-dedicated-routes-data-in-csv",
      {
        clientId: args.clientId,
        startDate: args.startDate,
        endDate: args.endDate,
      }
    ),
  exportRouteProgressData: (args: DdRouteProgressRequest) =>
    axiosRequests.post<any>(
      "/fdc-commandops/dedicated-delivery/export-route-progress-dedicated-routes-data-in-csv",
      {
        clientId: args.clientId,
        startDate: args.startDate,
        endDate: args.endDate,
      }
    ),
  storeRouteDataV2: (routesWrap: DdRouteDtoWrap) =>
    axiosRequests.post<DdRouteImportUIResponse>(
      "/fdc-commandops/dedicated-delivery/v2/persist-new-routes",
      {
        routeInfo: routesWrap.routes,
        client_id: routesWrap.clientId,
        createdBy: routesWrap.createdBy,
        updatedBy: routesWrap.updatedBy,
      }
    ),
  getStoreData: (args: StoreDataArgs) =>
    axiosRequests.getWithQueryParam<DdStorePerformanceUIResponse>(
      "/fdc-commandops/dedicated-delivery/overview-of-stores",
      {
        params: {
          clientId: args.clientId,
          storeIds: args.storeIds,
          startDate: args.startDate,
          endDate: args.endDate,
        },
      }
    ),
  getValuesByField: (
    startDateP: string,
    endDateP: string,
    columnName: string,
    clientId: number,
    storeId?: number
  ) => {
    return axiosRequests.getWithQueryParam<FilterValuesByFieldResponse>(
      "/fdc-commandops/dedicated-delivery/routes/unique-values-by-field",
      {
        params: {
          start_date: startDateP,
          end_date: endDateP,
          field_name: columnName,
          client_id: clientId,
          store_id: storeId,
        },
      }
    );
  },
  exportRouteData: (args: RouteExportDataArgs) =>
    axiosRequests.post<any>(
      "/fdc-commandops/dedicated-delivery/export-routes-data-in-csv",
      {
        clientId: args.clientId,
        routeIds: args.routeIds,
        startDate: args.startDate,
        endDate: args.endDate,
        filters: args.filters,
      }
    ),
  exportStoreData: (args: StoreDataArgs) =>
    axiosRequests.getWithQueryParam<any>(
      "/fdc-commandops/dedicated-delivery/export-store-overview-in-xlsx",
      {
        params: {
          clientId: args.clientId,
          storeIds: args.storeIds,
          startDate: args.startDate,
          endDate: args.endDate,
        },
        responseType: "blob",
      }
    ),

  exportStoreAssociatedRoutesData: (args: StoreAssociatedRoutesDataArgs) =>
    axiosRequests.post<any>(
      "/fdc-commandops/dedicated-delivery/export-store-associated-routes-data-in-csv",
      {
        clientId: args.clientId,
        storeId: args.storeId,
        routeIds: args.routeIds,
        startDate: args.startDate,
        endDate: args.endDate,
        filters: args.filters,
      }
    ),

  addClaimToStore: (args: AddClaimRequest) =>
    axiosRequests.post<any>("/fdc-commandops/dedicated-delivery/add-claims", {
      ddStoreId: args.ddStoreId,
      fdpId: args.fdpId,
      claimAmount: args.claimAmount,
      operationDate: args.operationDate,
      isEnabled: args.isEnabled,
      isInvoiced: args.isInvoiced,
      createdBy: args.createdBy,
      updatedBy: args.updatedBy,
    }),

  updateClaimToStore: (args: UpdateClaimRequest) =>
    axiosRequests.put<any>("/fdc-commandops/dedicated-delivery/edit-claims", {
      id: args.id,
      ddStoreId: args.ddStoreId,
      fdpId: args.fdpId,
      claimAmount: args.claimAmount,
      operationDate: args.operationDate,
      isEnabled: args.isEnabled,
      isInvoiced: args.isInvoiced,
      updatedBy: args.updatedBy,
    }),

  addLateCancelToStore: (args: AddLateCancelRequest) =>
    axiosRequests.post<any>(
      "/fdc-commandops/dedicated-delivery/add-late-cancels",
      {
        ddStoreId: args.ddStoreId,
        fdpId: args.fdpId,
        operationDate: args.operationDate,
        noOfRoutes: args.noOfRoutes,
        isEnabled: args.isEnabled,
        isInvoiced: args.isInvoiced,
        createdBy: args.createdBy,
        updatedBy: args.updatedBy,
      }
    ),

  updateLateCancelToStore: (args: UpdateLateCancelRequest) =>
    axiosRequests.put<any>(
      "/fdc-commandops/dedicated-delivery/edit-late-cancels",
      {
        id: args.id,
        ddStoreId: args.ddStoreId,
        fdpId: args.fdpId,
        operationDate: args.operationDate,
        noOfRoutes: args.noOfRoutes,
        isEnabled: args.isEnabled,
        isInvoiced: args.isInvoiced,
        updatedBy: args.updatedBy,
      }
    ),

  exportLandingPageData: (args: LangingPageExportDataArgs) =>
    axiosRequests.getWithQueryParam<any>(
      "/fdc-commandops/dedicated-delivery/export-client-overview-in-csv",
      {
        params: {
          startDate: args.startDate,
          endDate: args.endDate,
        },
      }
    ),

  persistNewStoreData: (addStoreDetails: AddStoreRequest) =>
    axiosRequests.post<any>(
      "/fdc-commandops/dedicated-delivery/persist-new-store",
      {
        store: { ...addStoreDetails },
        createdBy: addStoreDetails.createdBy,
        updatedBy: addStoreDetails.updatedBy,
      }
    ),

  checkIfStoreAlreadyExists: (
    storeValidationInfo: StoreAddOrUpdateValidation
  ) =>
    axiosRequests.get<any>(
      `/fdc-commandops/dedicated-delivery/exist-by-store-and-client?clientId=${storeValidationInfo.clientId}&clientStoreId=${storeValidationInfo.clientStoreId}`
    ),

  editExistingStoreData: (addStoreDetails: EditStoreRequest) =>
    axiosRequests.post<any>("/fdc-commandops/dedicated-delivery/edit-store", {
      store: { ...addStoreDetails },
      updatedBy: addStoreDetails.updatedBy,
    }),

  getClientData: (clientId: number) =>
    axiosRequests.getWithQueryParam<DdGeneralClientUIResponse>(
      "/fdc-commandops/dedicated-delivery/client-details",
      {
        params: {
          client_id: clientId,
        },
      }
    ),
  bulkImportStores: (args: BulkStoreIngestionWrapper) =>
    axiosRequests.post<BulkStoreIngestionResponse>(
      "/fdc-commandops/dedicated-delivery/persist-new-stores",
      {
        stores: args.stores,
        clientId: args.clientId,
        createdBy: args.createdBy,
        updatedBy: args.updatedBy,
      }
    ),

  persistNewRtsData: (addRtsDetails: AddRtsRequest) =>
    axiosRequests.post<RtsUIResponse>(
      "/fdc-commandops/rts/save",
      addRtsDetails
    ),
  persistMultiRtsData: (multiRts: AddRtsRequest[]) =>
    axiosRequests.post<RtsUIResponse>("/fdc-commandops/rts/save/all", multiRts),

  editRtsData: (editRtsDetails: EditRtsRequest) =>
    axiosRequests.put<RtsUIResponse>("/fdc-commandops/rts", editRtsDetails),

  getFdpAssociatedClients: (fdpId: number) =>
    axiosRequests.getWithQueryParam<ClientUIResponse>(
      "/fdc-commandops/dedicated-delivery/fdp-clients",
      { params: { fdpId: fdpId } }
    ),

  updateTotalOrdersForRoute: (routeId: string, totalOrders: number) =>
    axiosRequests.put<any>(
      `/fdc-commandops/dedicated-delivery/update/beluga-orders`,
       { routeId: routeId, ordersTotal: totalOrders }
    ),
    updateOrdersDeliveredForRoute: (routeId: string, delieveredOrders: number) =>
    axiosRequests.put<any>(
      `/fdc-commandops/dedicated-delivery/update/beluga-orders`,
       { routeId: routeId, ordersDelivered: delieveredOrders }
    ),
};
